var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12c-3.548 0-5.357-2.934-5.897-3.998C2.644 6.948 4.473 4 8 4c3.549 0 5.358 2.934 5.897 3.997C13.356 9.053 11.527 12 8 12zm0-9C3 3 1 8 1 8s2 5 7 5 7-5 7-5-2-5-7-5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5c-.827 0-1.5-.673-1.5-1.5S7.173 6.5 8 6.5s1.5.673 1.5 1.5S8.827 9.5 8 9.5zm0-4a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: "#fff"
  })));
}

export default SvgIconEyeOpen;